import api from "../middlware/api";
import { BASE_URL } from "../constants";

export type StockIssueStatus = "requested" | "issued";

export interface CreateStockIssueItemPayload {
  pharmacy_item_id: number;
  batch_id: number;
  quantity: number;
}

export interface CreateStockIssuePayload {
  department_id: number;
  requested_by_user_id?: number | null;
  status?: StockIssueStatus;
  issue_date?: string | null;
  notes?: string | null;
  items: CreateStockIssueItemPayload[];
}

export const getStockIssues = (params?: Record<string, any>) => {
  return new Promise((resolve, reject) => {
    const query = new URLSearchParams();
    if (params) {
      for (const key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
    }
    const queryString = query.toString();
    const url = queryString
      ? `${BASE_URL}/api/v1/stock-issues?${queryString}`
      : `${BASE_URL}/api/v1/stock-issues`;

    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getStockIssueById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/stock-issues/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const createStockIssue = (payload: CreateStockIssuePayload) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/stock-issues`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateStockIssueStatus = (
  id: number,
  payload: { status: "issued"; issue_date?: string }
) => {
  return new Promise((resolve, reject) => {
    api
      .patch(`${BASE_URL}/api/v1/stock-issues/${id}/status`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
